import { ga } from "client/utils/adsense/ga";
import { gtag } from "client/utils/adsense/gtag";
import { useState } from "react";
import { Source } from "store/features/colorPicker/types";
import copy from "copy-to-clipboard"

let copyFromImageCount = 0;
let copyFromColorCount = 0;

export const useColorPickerClipboard = (source: Source) => {
    const [isCopied, setIsCopied] = useState(false);

    const handleCopyFromImageAnalytics = () => {
        ga("send", {
            hitType: "pageview",
            page: "/vp/color_picker/color_copied_image/",
            title: "Color Picker Color Copied From Image",
        });

        ///event
        gtag("event", "Color Copied", {
            event_category: "Color Picker From Image",
            event_label: "Editor Page",
        });
    };

    const handleCopyFromColorAnalytics = () => {
        ga("send", {
            hitType: "pageview",
            page: "/vp/color_picker/color_copied_wheel/",
            title: "Color Picker Color Copied From Wheel",
        });

        // event
        gtag("event", "Color Copied", {
            event_category: "Color Picker From Wheel",
            event_label: "Editor Page",
        });
    };

    const handleCount = () => {
        if (source === "image") {
            copyFromImageCount++;
            copyFromImageCount < 2 && handleCopyFromImageAnalytics();
        } else {
            copyFromColorCount++;
            copyFromColorCount < 2 && handleCopyFromColorAnalytics();
        }
    };

    const handleCopy = async (text: string) => {
        try {
            console.time("copy");
            copy(text);

            setIsCopied(true);
            handleCount();

            setTimeout(() => {
                console.timeEnd("copy");
                setIsCopied(false);
            }, 1_500);
        } catch (_e) {}
    };

    return { isCopied, handleCopy };
};
